import React from 'react';
import Header from '../Component/Header';
import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import AdminService from '../Services/AdminService';

const AdminPanel = () => {
    const [activeTab, setActiveTab] = useState("True");
    const [searchTerm, setSearchTerm] = useState("");
    const [CompanyDetails, setCompanyDetails] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const UserRoleID = localStorage.getItem('RoleID');
    const [LogingUserCompanyID,SetLogingUserCompanyID]=useState();

    useEffect(() => {
        const token = localStorage.getItem("JWTToken");
        if (token) {
            if (UserRoleID === "3" || UserRoleID === "4" || UserRoleID === "5") {
                // Fetch survey details from API
                const fetchCompanyDetails = async () => {
                    try {
                        const response = await AdminService.GetCompaniesData(token);
                        if (response) {
                            console.log(response);
                            setCompanyDetails(response.Company_Details);
                            setLoading(false);
                        }
                    } catch (error) {
                        console.error("Error fetching survey details:", error);
                    }
                };
                const GetLoginCompanyData = async () => {
                    try {
                        const response = await AdminService.GetUserCompanyDetails(token);
                        if (response) {
                            const CompanyData=response.RESPONSE[0];
                            SetLogingUserCompanyID(CompanyData.CompanyUID)
                        }
                    } catch (error) {
                        console.error(error);
                    }
                }
                GetLoginCompanyData();
                fetchCompanyDetails();
            }else {
                navigate("/SurveyList");
            }
        } else {
            navigate("/Login");
        }
    }, [navigate, UserRoleID]);

    const handleTabChange = (tab) => setActiveTab(tab);

    const categorizedCompany = {
        True: CompanyDetails.filter(Company => Company.Status === "True"),
        False: CompanyDetails.filter(Company => Company.Status === "False"),
    };

    // Filter surveys by search term for the active tab
    const filteredCompanys = categorizedCompany[activeTab]?.filter((Company) => {
        return Company.CompanyName.toLowerCase().includes(searchTerm.toLowerCase());
    });
    const CompanysCard = ({ Company }) => {
        return (
            <div className="card Box m-2 p-3 shadow-sm" style={{ width: "18rem", height: "16rem" }}>
                <div className="card-body p-0 d-flex flex-column justify-content-between">
                    <div className='d-flex justify-content-between align-items-start'>
                        <div className='bg-grey max-width85px' style={{ minHeight: "60px" }}>
                            <img src={Company.CompanyLogo} className='w-100' alt="Img..." />
                        </div>
                    </div>
                    <h6 className="card-title fw-bold">
                        {Company.CompanyName.length > 40
                            ? `${Company.CompanyName.slice(0, 40)}...`
                            : Company.CompanyName}
                    </h6>
                    <div>
                        <p className="card-text mb-2">Contact Mail:- {Company.ContactMail || "No Contact Mail"} </p>
                        <p className="card-text mb-2">Contact Number:- {Company.ContactNumber || "No Contact Number"} </p>
                        <p className="card-text mb-2">
                            Member Since:- {Company.MemberSince}
                        </p>
                    </div>
                    <div className='text-end'>
                        <Link to={`/ManageCompanyProfile/${Company.CompanyUID}`} className='text-dark'>
                               <i className="fa-solid fa-arrow-right"></i>
                        </Link>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <>
            <Header />
            <div className='min-hight85vh'>
                <div className="container-fuild bg-Truvey py-5">
                    <div className="container">
                        <div className="row justify-content-evenly">
                            <div className="Box p-4" style={{ minHeight: "200px", maxWidth: "350px" }}>
                                <div>
                                    <h5 className="text-lg font-bold text-black">Company Profile</h5>
                                </div>
                                <p className="w-4/5 text-xl font-semibold text-green-100">Manage your Company Profile</p>
                                <div className="">
                                    <Link to={`/ManageCompanyProfile/${LogingUserCompanyID}`} className='py-2 TruveyHoverBtn br-5 cursor px-3'> Update Profile</Link>
                                </div>
                            </div>
                            <div className="Box p-4" style={{ minHeight: "200px", maxWidth: "350px" }}>
                                <div className='d-flex justify-content-between'>
                                    <div className="">
                                        <span>Daily Active Users</span>
                                        <p><b>100</b></p>
                                    </div>
                                    <div className="">
                                        <span>Total Active Users </span>
                                        <p><b> 100</b></p>
                                    </div>
                                </div>
                                <div className="">
                                    <span>Total Active Users </span>
                                    <p><b> 100</b></p>
                                </div>
                            </div>
                            <div className="Box p-4" style={{ minHeight: "200px", maxWidth: "350px" }}>
                                <div className="mt-3">
                                    <div className="flex-wrap d-flex justify-content-between ">
                                        <div>
                                            <h5 className="text-lg font-bold text-black">  Manage Users
                                            </h5>
                                            Manage your agreements
                                        </div>
                                        <div>
                                            <Link to={`/ManageCompanyProfile/${LogingUserCompanyID}`} state={{ defaultTab: "Members" }} className='Gold'>
                                                <i className="fa-solid fa-arrow-right"></i>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {
                        UserRoleID === "3" || UserRoleID === "4" ? (<>

                            <div className="container py-4">
                                {/* Tabs for switching between survey categories */}
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <div className="nav nav-tabs">
                                        <button
                                            className={`nav-link ${activeTab === "True" ? "active" : ""}`}
                                            onClick={() => handleTabChange("True")}
                                        >
                                            Active
                                        </button>
                                        <button
                                            className={`nav-link ${activeTab === "False" ? "active" : ""}`}
                                            onClick={() => handleTabChange("False")}
                                        >
                                            Inactive
                                        </button>
                                    </div>
                                    <input
                                        type="text"
                                        placeholder="Search..."
                                        className="form-control w-25"
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                    />
                                </div>

                                {/* Loading State */}
                                {loading ? (
                                    <div className="spinner-border" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                ) : (
                                    <div className="d-flex flex-wrap align-items-center">
                                        <Link to={"/CreateCompany"}>
                                            <div className="card TruveyBG Box m-2 p-3 shadow-sm" style={{ width: "10rem", height: "16rem" }}>
                                                <div className="card-body p-0 d-flex flex-column justify-content-center align-item-center text-center">
                                                    <h6 className="card-title fw-bold text-white">New Company</h6>
                                                </div>
                                            </div>
                                        </Link>
                                        {filteredCompanys?.length > 0 ? (
                                            filteredCompanys.map(Company => (
                                                <CompanysCard key={Company.CompanyID} Company={Company} />
                                            ))
                                        ) : (
                                            <p className="text-muted">No company data available.</p>
                                        )}
                                    </div>
                                )}
                            </div>
                        </>) : (<></>)
                    }
                    
                </div>
            </div>
        </>
    );
};

export default AdminPanel;